import { calculateTotalDue, getTotalPayments } from '../../util/Billing';
import { STATUSES } from '../renderers/billing/PaymentStatusRenderer';
export default {
  id: 'bill.paymentStatus',
  name: 'bill.paymentStatus',
  displayName: 'Status',
  valueType: 'string',
  objectType: 'bill',
  placement: {
    group: []
  },
  get: obj => {
    const due = calculateTotalDue(obj);
    const paid = getTotalPayments(obj);
    if (due === 0) {
      return STATUSES.paid;
    }
    if (due > 0) {
      if (paid > 0) {
        return STATUSES.partiallyPaid;
      }
      return STATUSES.notPaid;
    }
    if (due < 0) {
      return STATUSES.overpaid;
    }
    return null;
  }
};